import { type UpdatePromotionPlan } from '@onr/schema'

import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export const useUpdatePromotionPlan = (options?: OnrApiMutationOptions<void, UpdatePromotionPlan>) =>
  useOnrApi<void, UpdatePromotionPlan>({ type: 'updatePromotionPlan', ...options })
